import React, { useEffect, useState, useRef } from 'react'
import GenericCustomButton from './GenericCustomButton'
import Icons from '../assets/icons';
import LanguageTranslator from '../locals/LanguageTranslator';

function AppliedFiltersPopUp(props) {

    const { isAppliedFilterModalOpen, itemFiltersHeadersData } = props;

    const modalRef = useRef(null);

    const [appliedFilters, setAppliedFilters] = useState(props?.appliedFilters || {})
    const [headersData, setHeadersData] = useState(props?.headersData || {})
    const [headersType, setHeadersType] = useState(props?.headersType || {})
    const [modalFromTop, setModalFromTop] = useState(0)

    useEffect(() => {
        setAppliedFilters(props?.appliedFilters || {});
    }, [props?.appliedFilters])

    useEffect(() => {
        setTimeout(() => {
            document.addEventListener('click', hideModal);
        }, 0)
        return () => {
            document.removeEventListener('click', hideModal);
        };
    }, [])

    useEffect(() => {
        //   console.log("val: ", modalRef?.current)
        const modalFromTop = modalRef?.current?.getBoundingClientRect()?.top;
        setModalFromTop(modalFromTop);
    }, [modalRef])

    const hideModal = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            props?.handleTrueFalse("showAppliedFilters", false);
        }
    }

    const getFilterValue = (key) => {
        if (headersData?.main?.columnType?.[key]) {
            switch (headersData?.main?.columnType?.[key]) {
                case "NUMBER":
                case "TIME": {
                    return <span className='afpbr-value'>From {appliedFilters?.[key]?.from} to {appliedFilters[key].to}</span>;
                }
                case "LOV": case "SEARCH": {
                    if (typeof appliedFilters?.[key] == "string") {
                        return checkOthersValue(appliedFilters?.[key])
                    }
                    else if (Array.isArray(appliedFilters?.[key])) {
                        return appliedFilters?.[key]?.map((itemVal) => {
                            return <span className='afpbr-value'>{itemVal}</span>
                        })
                    }
                }
                case "DATE": {
                    if (!appliedFilters?.[key]?.key)
                        return <span className='afpbr-value'>From {appliedFilters?.[key]?.from} to {appliedFilters?.[key]?.to}</span>;
                    else if (appliedFilters?.[key]?.key === "SM_DATE_TODAY_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Today</LanguageTranslator></span>;
                    else if (appliedFilters?.[key]?.key === "SM_DATE_YESTERDAY_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Yesterday</LanguageTranslator></span>;
                    else if (appliedFilters?.[key]?.key === "SM_DATE_LAST7DAYS_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Last 7 Days</LanguageTranslator></span>;
                    else if (appliedFilters?.[key]?.key === "SM_DATE_LASTWEEK_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Last Week</LanguageTranslator></span>;
                    else if (appliedFilters?.[key]?.key === "SM_DATE_THISMONTH_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>This Month</LanguageTranslator></span>;
                    else if (appliedFilters?.[key]?.key === "SM_DATE_LASTMONTH_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Last Month</LanguageTranslator></span>;
                    return <span className='afpbr-value'></span>;
                }
                default: {
                    if(typeof appliedFilters?.[key] == "object") {
                        return <span className='afpbr-value'> From {appliedFilters?.[key]?.from} to {appliedFilters?.[key]?.to}</span>
                    }
                    else if (appliedFilters?.[key] == "SM_TEXT_EMPTY_VALUE")
                        return <span className='afpbr-value'>is Empty</span>;
                    else if (appliedFilters?.[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                        return <span className='afpbr-value'>is Not Empty</span>;
                    else
                        return <span className='afpbr-value'>{appliedFilters?.[key]}</span>;
                }
            }

        }
        else if(appliedFilters?.[key]) {
            if(typeof appliedFilters?.[key] == "object") {
                return <span className='afpbr-value'> From {appliedFilters?.[key]?.from} to {appliedFilters?.[key]?.to}</span>
            }
            else if (appliedFilters?.[key] == "SM_TEXT_EMPTY_VALUE")
                return <span className='afpbr-value'>is Empty</span>;
            else if (appliedFilters?.[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                return <span className='afpbr-value'>is Not Empty</span>;
            else
                return <span className='afpbr-value'>{appliedFilters?.[key]}</span>;
        }
    }

    const checkOthersValue = (value) => {
        if (value == "SM_TEXT_EMPTY_VALUE")
            return <span className='afpbr-value'>is Empty</span>;
        else if (value == "SM_TEXT_NOT_EMPTY_VALUE")
            return <span className='afpbr-value'>is Not Empty</span>;
        else return value?.split(",")?.map((itemVal) => {
            return <span className='afpbr-value'>{itemVal}</span>
        })
    }

    const getExistingItemFilterValue = (key, filterValue) => {
        if(headersData?.item?.columnType?.[key]) {
            switch (headersData?.item?.columnType?.[key]) {
                case "NUMBER":
                case "TIME": {
                    return <span className='afpbr-value'>From {filterValue[key].from} to {filterValue[key].to}</span>;
                }
                case "LOV": case "SEARCH": {
                    if (typeof filterValue?.[key] == "string") {
                        return checkOthersValue(filterValue?.[key])
                    }
                    else if (Array.isArray(filterValue?.[key])) {
                        return filterValue[key]?.map((itemVal) => {
                            return <span className='afpbr-value'>{itemVal}</span>
                        })
                    }
                }
                case "DATE": {
                    if (!filterValue?.[key]?.key)
                        return <span className='afpbr-value'>From {filterValue?.[key]?.from} to {filterValue?.[key]?.to}</span>;
                    else if (filterValue?.[key]?.key === "SM_DATE_TODAY_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Today</LanguageTranslator></span>;
                    else if (filterValue?.[key]?.key === "SM_DATE_YESTERDAY_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Yesterday</LanguageTranslator></span>;
                    else if (filterValue?.[key]?.key === "SM_DATE_LAST7DAYS_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Last 7 Days</LanguageTranslator></span>;
                    else if (filterValue?.[key]?.key === "SM_DATE_LASTWEEK_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Last Week</LanguageTranslator></span>;
                    else if (filterValue?.[key]?.key === "SM_DATE_THISMONTH_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>This Month</LanguageTranslator></span>;
                    else if (filterValue?.[key]?.key === "SM_DATE_LASTMONTH_VALUE")
                        return <span className='afpbr-value'><LanguageTranslator>Last Month</LanguageTranslator></span>;
                    return "";
                }
                default: {
                    if (filterValue?.[key] == "SM_TEXT_EMPTY_VALUE")
                        return <span className='afpbr-value'>is Empty</span>;
                    else if (filterValue?.[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                        return <span className='afpbr-value'>is Not Empty</span>;
                    else
                        return <span className='afpbr-value'>{filterValue?.[key]}</span>;
                }
            }
        }
        else if(filterValue?.[key]) {
            if (filterValue?.[key] == "SM_TEXT_EMPTY_VALUE")
                return <span className='afpbr-value'>is Empty</span>;
            else if (filterValue?.[key] == "SM_TEXT_NOT_EMPTY_VALUE")
                return <span className='afpbr-value'>is Not Empty</span>;
            else
                return <span className='afpbr-value'>{filterValue?.[key]}</span>;
        }
    }

    const clearFilter = () => {
        props?.clearFilter();
        props?.handleTrueFalse("showAppliedFilters", false);
    }

    const clearSingleFilter = (key) => {
        const preserveKeys = props?.preserveFilterKeys || [];
        if (preserveKeys.includes(key)) return;
        let filters = { ...appliedFilters };
        if(filters?.[key] || key in filters) {
            delete filters[key]
        }
        else if(filters?.item?.[key]) {
            delete filters.item[key]
        }
        setAppliedFilters(filters);
        const remainingKeys = Object.keys(filters || {}).filter(k => !preserveKeys.includes(k) && k !== 'item');
        const remainingItemKeys = filters?.item ? Object.keys(filters.item || {}) : [];
        if(remainingKeys.length === 0 && remainingItemKeys.length === 0) {
            props?.handleTrueFalse("showAppliedFilters", false);
            props?.applyFilter({})();
        }
        else {
            props?.applyFilter(filters)();
        }
    }

    const toCamelCase = (str) => {
        return str?.replace?.(/_([a-z])/g, (_, char) => char?.toUpperCase?.());
    };

    const getItemFilterHeader = (key) => {
        if(headersData?.item?.[headersType?.item]?.[key]) {
            return headersData?.item?.[headersType?.item]?.[key]
        }
        else if(itemFiltersHeadersData?.["Default Headers"]?.[key]) {
            return itemFiltersHeadersData?.["Default Headers"]?.[key]
        }
        else if(itemFiltersHeadersData?.["Custom Headers"]?.[key]) {
            return itemFiltersHeadersData?.["Custom Headers"]?.[key]
        }
        else if (headersData?.item?.[headersType?.item]?.[toCamelCase?.(key)]) {
            return headersData?.item?.[headersType?.item]?.[toCamelCase?.(key)]
        }
        else return ""
    }

    return (
        <div style={{boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 30px'}} className={`applied-filters-popup max-w-[500px] leading-[12px] text-[11px] overflow-x-hidden overflow-y-auto bg-white min-w-[400px] absolute top-full mt-[.5rem] z-[40] duration-300 left-0 ${isAppliedFilterModalOpen ? 'appliedFilterModalOpen opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} ref={modalRef}>
            <div className='afp-head px-4 pt-[1rem]'>
                <LanguageTranslator tag='h3' className='font-bold mb-3 text-sm leading-[12px]'>Applied Filters</LanguageTranslator>
                <LanguageTranslator tag='p' className='text-[#525676] italic'>Below are the filters applied to your search terms. You can save these as a quick filter for future use.</LanguageTranslator>
            </div>
            <div className="afp-body max-h-[30vh] overflow-y-auto px-4 pb-2" style={{
                maxHeight: 200
            }}>
                {Object.keys(appliedFilters || {})?.filter(key => !(props?.preserveFilterKeys || []).includes(key))?.map((key) => {
                    if (key === "item") {
                        return Object.keys(appliedFilters?.item || {})?.map(newKey => (
                            <div className="filterDet mt-[1rem] mb-2">
                                <LanguageTranslator tag='label' className='filterLabel'>{getItemFilterHeader(newKey)}</LanguageTranslator>
                                <div className='filterData flex items-center flex-wrap gap-2'>
                                    {getExistingItemFilterValue(newKey, appliedFilters?.item)}
                                    <span className='clear-filter bg-[#f6f6f6] rounded-[50%] cursor-pointer ml-[3px] p-[3px] hover:bg-primary' onClick={()=> clearSingleFilter(newKey)}><Icons.ModalCloseIcon /></span>
                                </div>
                            </div>
                        ))
                    }
                    return <div className="filterDet mt-[1rem] mb-2">
                        <LanguageTranslator tag='label' className='filterLabel'>{headersData?.main?.[headersType?.main][key] || key}</LanguageTranslator>
                        <div className='filterData flex items-center flex-wrap gap-2'>
                            {getFilterValue(key)}
                            <span className='clear-filter bg-[#f6f6f6] rounded-[50%] cursor-pointer ml-[3px] p-[3px] hover:bg-primary' onClick={()=> clearSingleFilter(key)}><Icons.ModalCloseIcon /></span>
                        </div>
                    </div>
                })}
            </div>
            <div className="afp-footer border-t border-borderSlateGrey py-3 px-2">
                <GenericCustomButton label="Clear Filter" type='default' onClick={() => clearFilter()} />
                <GenericCustomButton  sendEventAnalyticsToGoogle = {true} label={`Save as “Quick Filter”`} type="primary" onClick={() => props?.saveFilters()} />
            </div>
        </div>
    )
}

export default AppliedFiltersPopUp